import { isRadioElement as n } from "./is.js";
var i = function(r, e) {
  return e.filter(n).filter(function(t) {
    return t.name === r.name;
  }).filter(function(t) {
    return t.checked;
  })[0] || r;
}, u = function(r, e) {
  return n(r) && r.name ? i(r, e) : r;
}, f = function(r) {
  var e = /* @__PURE__ */ new Set();
  return r.forEach(function(t) {
    return e.add(u(t, r));
  }), r.filter(function(t) {
    return e.has(t);
  });
};
export {
  u as correctNode,
  f as correctNodes
};
